import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { getMe, logout as apiLogout } from '../api/auth';
import { getToken } from '../api/client';
import type { Tenant } from '../api/types';

interface AuthCtx {
  tenant: Tenant | null;
  loading: boolean;
  refreshMe: () => Promise<void>;
  logout: () => void;
}

const Ctx = createContext<AuthCtx>({
  tenant: null, loading: true,
  refreshMe: async () => {}, logout: () => {},
});

export function AuthProvider({ children }: { children: ReactNode }) {
  const [tenant, setTenant] = useState<Tenant | null>(null);
  const [loading, setLoading] = useState(true);

  const refreshMe = async () => {
    if (!getToken()) {
      setTenant(null);
      setLoading(false);
      return;
    }
    try {
      setTenant(await getMe());
    } catch {
      setTenant(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { void refreshMe(); }, []);

  const logout = () => {
    apiLogout();
    setTenant(null);
    window.location.href = '/login';
  };

  return <Ctx.Provider value={{ tenant, loading, refreshMe, logout }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
